import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const Terms: React.FC = () => {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <div className="max-w-3xl mx-auto px-6 py-12">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground transition-colors mb-8">
          <ArrowLeft className="w-4 h-4" /> Back to home
        </Link>

        <h1 className="text-3xl font-bold mb-2">Terms of Service</h1>
        <p className="text-sm text-muted-foreground mb-10">Last updated: {new Date().toLocaleDateString()}</p>

        <section className="space-y-3 mb-8">
          <h2 className="text-xl font-semibold">1. Acceptance</h2>
          <p className="text-sm text-muted-foreground leading-relaxed">
            By accessing or using AutoTradePlug, you agree to these Terms. If you do not agree, do not use the
            service. These Terms form a binding agreement between you and <span className="font-medium">[YOUR COMPANY NAME]</span>.
          </p>
        </section>

        <section className="space-y-3 mb-8">
          <h2 className="text-xl font-semibold">2. Service Description</h2>
          <p className="text-sm text-muted-foreground leading-relaxed">
            AutoTradePlug provides an execution and analytics platform for automated and discretionary trading
            strategies. We offer tools to deploy strategies, connect brokers you authorize, and monitor performance.
            We do not custody funds.
          </p>
        </section>

        <section className="space-y-3 mb-8 border border-border rounded-xl p-5 bg-muted/30">
          <h2 className="text-xl font-semibold">3. Financial Disclaimer</h2>
          <p className="text-sm text-foreground leading-relaxed font-medium">
            AutoTradePlug is not a financial advisor, broker-dealer, or investment manager. Nothing on the platform
            constitutes investment, tax, or legal advice. Trading carries substantial risk of loss and is not
            suitable for every investor. Past performance is not indicative of future results. You are solely
            responsible for your trading decisions and outcomes.
          </p>
        </section>

        <section className="space-y-3 mb-8">
          <h2 className="text-xl font-semibold">4. Limitation of Liability</h2>
          <p className="text-sm text-muted-foreground leading-relaxed">
            To the maximum extent permitted by law, AutoTradePlug and its affiliates are not liable for any indirect,
            incidental, consequential, or punitive damages, including lost profits, trading losses, or data loss,
            arising from your use of the service. Total aggregate liability is limited to fees paid in the prior
            twelve months.
          </p>
        </section>

        <section className="space-y-3 mb-8">
          <h2 className="text-xl font-semibold">5. Governing Law</h2>
          <p className="text-sm text-muted-foreground leading-relaxed">
            These Terms are governed by the laws of the jurisdiction of <span className="font-medium">[YOUR COMPANY NAME]</span>'s
            registered office, without regard to conflict-of-law principles. For questions, contact{' '}
            <span className="font-medium">[YOUR EMAIL]</span>.
          </p>
        </section>
      </div>
    </div>
  );
};

export default Terms;
